module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e63cba8e439578f337a8165515cbb43f.png";